module.exports = __webpack_public_path__ + "static/media/becher.08c11c25.png";